import { Injectable, computed, inject } from '@angular/core';
import { httpResource } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccessRequestService } from '../Services/access-request.service';
import { AccessRequestResponse, AccessRequestStatus } from '../Interfaces/api/access-request.interface';
import { ResourceStateService } from '../Modules/Shared/Services/resource-state.service';

@Injectable()
export class AccessRequestFacade {
    private readonly _resourceState = inject(ResourceStateService);

    private readonly _accessRequestService = inject(AccessRequestService);

    private readonly _statusResource = httpResource<AccessRequestResponse>(() =>
        this._accessRequestService.status(),
    );

    // ACTIONS
    public reload() {
        this._statusResource.reload();
    }

    public send(): Observable<AccessRequestResponse> {
        return this._accessRequestService.send();
    }

    // PUBLIC READ MODELS
    readonly status = computed<AccessRequestStatus | null>(() => {
        if (!this._statusResource.hasValue()) {
            return null;
        }
        return this._resourceState.valueOf(this._statusResource)?.data ?? null;
    });

    readonly lastRequestedAt = computed<string | null>(() => this.status()?.last_requested_at ?? null);
    readonly nextAllowedAt = computed<string | null>(() => this.status()?.next_allowed_at ?? null);
    readonly windowHours = computed<number | null>(() => this.status()?.window_hours ?? null);

    readonly isThrottled = computed<boolean>(() => {
        const nextAllowedAt = this.nextAllowedAt();
        return nextAllowedAt !== null && new Date(nextAllowedAt).getTime() > Date.now();
    });

    readonly isLoading = computed(() => this._statusResource.isLoading());
    readonly error = computed(() => this._statusResource.error());
}
